// Real reviews from Colings air bnb
const Reviews = [
    {
        id: 0,
        name: "John",
        said: "Great space, convenient location."
    },
    {
        id: 1,
        name: "Jackie",
        said: "This is a lovely apartment to stay in. It is very clean, nicely furnished and equipped with easy off-road parking. The living room is spacious but cosy."
    },
    {
        id: 2,
        name: "Kat",
        said: "Great apartment, clean and has everything you need! Thanks Colin"
    },
    {
        id: 3,
        name: "Sarah",
        said: "We thoroughly enjoyed staying here. It was a lovely, spacious apartment and tastefully decorated. Within walking distance of a great park for the dogs. Would recommend."
    },
    {
        id: 4,
        name: "Stacey",
        said: "Lovely spacious apartment and good location for exploring Ilfracombe and neighbouring towns."
    },
    {
        id: 5,
        name: "Nicki",
        said: "We enjoyed another great stay at this lovely attic apartment. Colin, is charming and quick to respond to questions. Enthusiastically recommend and we’ll certainly revisit."
    },
    {
        name: "Joyce",
        said: "Beautiful appartment and excellent friendly service from Colin. Cannot fault anything. We were all very comfortable and happy here for our weekend stay. Thank you."
    },
    {
        name: "Benjamin",
        said: "Our second stay here. All perfect; as was the first stay. We'll be back!"
    },
    {
        name: "Leigh",
        said: "Great space, convenient location."
    },
    {
        name: "Paul",
        said: "Can not fault number 54 everything you need, town steady stroll away, few minutes in car or bus stop right outside accommodation. Would Recommend."
    },
    {
        name: "Dave",
        said: "Pretty much faultless stay. The place was very clean on arrival, with lots of toilet rolls, soap, dishcloth, teatowel and bin bags. Would not hesitate to recommend."
    },
    {
        name: "Suz",
        said: "The flat are in a great location. Very close to town and only 15 -20 min drive to woolacombe"
    },
    {
        name: "James",
        said: "A great little spot from which to explore the local area. A beautifully decorated and tidy little flat. Would recommend!"
    },
    {
        name: "Helen",
        said: "Colin was a great host and the apartment is lovely. Very spacious, really nicely decorated and in a great location. I would definitely recommend staying with Colin!"
    },
    {
        name: "Andy",
        said: "We had a lovely stay at this apartment. We all felt truly relaxed and recuperated following our stay. cannot recommend highly enough."
    },
    {
        name: "Sreekesh",
        said: "Great and peaceful stay"
    },
    {
        name: "Kelly",
        said: "Lovely apartment with unique decor that suits the property. I would definitely recommend Colin’s apartment as it has everything you would need for your stay! "
    },
    {
        name: "Pamela",
        said: "A lovely apartment, clean, comfy and well located. We had a great stay there and would definitely return"
    },
    {
        name: "Arun",
        said: "Check in was simple. Large apartment, everything you need. Clean and spacious. Location is brilliant for all local beaches."
    },

]

export default Reviews
